import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import './App.css';
import LaCarte from './LaCarte';

/* ======================== DATA ======================== */

const reviews = [
  { author: 'Antoine Manner', text: "Client depuis quelques années !! Toujours au top !", date: 'Il y a 2 mois' },
  { author: 'Vincent Becquart', text: "Très bon restaurant, environnement soigné, on passe toujours des bons moments ici merci à toute l'équipe", date: 'Il y a 3 mois' },
  { author: 'Sophie L.', text: "Très bon produit, je me suis régalée, j'adore leurs croquettes. Endroit très convivial.", date: 'Il y a 1 mois' },
  { author: 'Marc D.', text: "Tjrs un régal avec un service aimable et souriant.", date: 'Il y a 4 mois' },
  { author: 'Julie R.', text: "Toujours aussi convivial, ambiance chaleureuse et sympa.", date: 'Il y a 2 mois' },
  { author: 'Pierre M.', text: "Un lieu très chaleureux, un bel accueil. On se sent très bien conseillé sur les plats et aussi sur les vins.", date: 'Il y a 1 mois' },
  { author: 'Camille B.', text: "Une belle ambiance, cuisine excellente avec un serveur super aimable !", date: 'Il y a 3 mois' },
  { author: 'Thomas G.', text: "La paella au chorizo est délicieuse", date: 'Il y a 2 mois' },
  { author: 'Lucie F.', text: "Las Tapas 2026 : un très grand cru ! On en redemande", date: 'Il y a 1 mois' },
];

const foodPhotos = [
  'Tapas-26.jpeg', 'Tapas-24.jpeg', 'Tapas-23.jpeg', 'Tapas-20.jpeg',
  'Tapas-19.jpeg', 'Tapas-11.jpeg', 'Tapas-9.jpeg', 'Tapas-5.jpeg',
];

const galleryPhotos1 = [
  'Tapas-28.jpeg', 'Tapas-25.jpeg', 'Tapas-22.jpeg', 'Tapas-18.jpeg',
  'Tapas-16.jpeg', 'Tapas-14.jpeg', 'Tapas-12.jpeg', 'Tapas-10.jpeg',
  'Tapas-7.jpeg', 'Tapas-3.jpeg',
];

const galleryPhotos2 = [
  'Tapas-27.jpeg', 'Tapas-24.jpeg', 'Tapas-21.jpeg', 'Tapas-17.jpeg',
  'Tapas-13.jpeg', 'Tapas-11.jpeg', 'Tapas-6.jpeg',
];

/* ======================== COMPONENTS ======================== */

/** Header */
function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  interface NavLink {
    label: string;
    to?: string;
    href?: string;
    external?: boolean;
  }

  const navLinks: NavLink[] = [
    { label: 'Accueil', to: '/' },
    { label: 'La Carte', to: '/la-carte' },
    { label: 'Privatisation', href: isHome ? '#privatisation' : '/#privatisation' },
    { label: 'Galerie', href: isHome ? '#galerie' : '/#galerie' },
    { label: 'Contact', href: isHome ? '#contact' : '/#contact' },
    { label: 'Click & Collect', href: 'https://commands.zenchef.com/articles?rid=352016', external: true },
  ];

  const renderLink = (link: NavLink, onClick?: () => void) => {
    if (link.to) {
      return (
        <Link key={link.label} to={link.to} onClick={onClick}>
          {link.label}
        </Link>
      );
    }
    return (
      <a
        key={link.label}
        href={link.href}
        onClick={onClick}
        {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {link.label}
      </a>
    );
  };

  return (
    <>
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <Link to="/" className="header-logo">
          <img src="/assets/Las-Tapas.png" alt="Las Tapas" />
        </Link>
        <nav className="header-nav">
          {navLinks.map((link) => renderLink(link))}
          <a href="tel:+33320069659" className="header-phone">03 20 06 96 59</a>
        </nav>
        <div className="hamburger" onClick={() => setMenuOpen(true)}>
          <span /><span /><span />
        </div>
      </header>
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>✕</button>
        {navLinks.map((link) => renderLink(link, () => setMenuOpen(false)))}
        <a href="tel:+33320069659" onClick={() => setMenuOpen(false)}>03 20 06 96 59</a>
      </div>
    </>
  );
}

/** SVG Icons for social */
function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

/** Hero Section */
function Hero() {
  return (
    <section className="hero" id="accueil">
      <video className="hero-video" autoPlay muted loop playsInline
        poster="/assets/Tapas-3.jpeg">
        <source src="https://www.lastapas.fr/wp-content/uploads/2025/06/las-tapas-vieux-lille-1.mov" type="video/quicktime" />
      </video>
      <div className="hero-overlay" />
      <div className="hero-content fade-in-up">
        <h1>Las Tapas</h1>
        <p>
          Las Tapas fait vibrer vos soirées avec des tapas maison, une ambiance festive,
          une cave voûtée et un étage à privatiser.
        </p>
        <div className="hero-buttons">
          <Link to="/la-carte" className="btn-primary">La carte</Link>
          <a href="#privatisation" className="btn-secondary">Privatisation</a>
        </div>
        <div className="social-icons">
          <a href="https://www.facebook.com/lastapaslille" target="_blank" rel="noopener noreferrer">
            <FacebookIcon />
          </a>
          <a href="https://www.instagram.com/lastapas_lille/" target="_blank" rel="noopener noreferrer">
            <InstagramIcon />
          </a>
        </div>
      </div>
      {/* <div className="hero-decor-bottom">
        <img src="/assets/Las-Tapas-3.svg" alt="" />
      </div> */}
    </section>
  );
}

/** Ceramic Band */
function CeramicBand({ direction = 'ltr', onRed = false }: { direction?: 'ltr' | 'rtl'; onRed?: boolean }) {
  return (
    <div className={`ceramic-band ${onRed ? 'on-red' : ''}`}>
      <div className={`ceramic-scroll ${direction}`}>
        {[...Array(6)].map((_, i) => (
          <React.Fragment key={i}>
            <img src="/assets/ceramique.svg" alt="" />
            <img src="/assets/ceramique-copie.svg" alt="" />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

/** About Section */
function AboutSection() {
  return (
    <section className="about-section" id="carte">
      <div className="section-container">
        {/* Main About */}
        <div className="about-main">
          <div className="about-decor">
            <img src="/assets/Las-Tapas-8.svg" alt="" />
            <img src="/assets/Las-Tapas-4.svg" alt="" />
            <img src="/assets/Las-Tapas-33.svg" alt="" />
          </div>
          <div className="about-center">
            <h2>27 ans d'amour pour la cuisine espagnole</h2>
            <p>
              Las Tapas, c'est l'histoire d'un lieu à part dans le Vieux-Lille.
              Un restaurant chaleureux, où l'on partage des tapas authentiques,
              préparées maison avec passion. Ici, chaque soir est une fête.
              Une ode à la gastronomie espagnole, au bon vin, à la musique,
              et surtout à la convivialité.
            </p>
          </div>
          <div className="about-decor">
            <img src="/assets/Las-Tapas-6.svg" alt="" className="floating" />
            <img src="/assets/Las-Tapas-38.svg" alt="" />
            <img src="/assets/Las-Tapas-36.svg" alt="" />
          </div>
        </div>

        {/* Carte Tapas */}
        <div className="carte-tapas">
          <div className="carte-tapas-left">
            <h3 className="carte-title">CARTE</h3>
            <h3 className="tapas-title">TAPAS</h3>
            <img src="/assets/Las-Tapas-15.svg" alt="" style={{ maxWidth: 200, marginTop: 20 }} />
          </div>
          <div className="carte-tapas-right">
            <img src="/assets/Las-Tapas-17.svg" alt="" />
            <img src="/assets/Las-Tapas-26.svg" alt="" />
            <img src="/assets/Las-Tapas-14.svg" alt="" />
            <img src="/assets/Las-Tapas-19.svg" alt="" />
          </div>
        </div>

        {/* Food Carousel */}
        <div className="food-carousel-section">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={4}
            loop
            autoplay={{ delay: 2034, disableOnInteraction: false }}
            breakpoints={{
              0: { slidesPerView: 1.5 },
              480: { slidesPerView: 2.5 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            {foodPhotos.map((photo) => (
              <SwiperSlide key={photo}>
                <img src={`/assets/${photo}`} alt="Tapas" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Decorative images */}
        <div className="section-decor-img">
          <img src="/assets/Las-Tapas-20.svg" alt="" />
        </div>

        {/* Tapas Maison */}
        <div className="tapas-maison">
          <div className="decor-col">
            <img src="/assets/Las-Tapas-41.svg" alt="" />
            <img src="/assets/Las-Tapas-16.svg" alt="" />
            <img src="/assets/Las-Tapas-35.svg" alt="" />
            <img src="/assets/Las-Tapas-23.svg" alt="" />
          </div>
          <div className="tapas-maison-center">
            <h3>Des tapas faites maison, à savourer ensemble</h3>
            <p>
              Plus de 30 tapas au menu, des classiques comme la tortilla ou les croquetas,
              aux créations maison comme les aubergines panées au miel de canne.
              Le tout accompagné de vins espagnols soigneusement sélectionnés ou de
              notre sangria artisanale. À Las Tapas, on picore, on trinque, on savoure.
            </p>
            <h4>100 % fait maison</h4>
            <p>
              Des tapas préparés sur place, selon les recettes de tradition espagnole
              — simples, généreuses et authentiques.
            </p>
            <Link to="/la-carte" className="btn-primary bounce">La carte</Link>
          </div>
          <div className="decor-col">
            <img src="/assets/Las-Tapas-7.svg" alt="" className="floating" />
            <img src="/assets/Las-Tapas-31.svg" alt="" />
            <img src="/assets/Las-Tapas-22.svg" alt="" />
            <img src="/assets/Las-Tapas-32.svg" alt="" />
          </div>
        </div>

        <div className="section-decor-img">
          <img src="/assets/Las-Tapas-25.svg" alt="" />
        </div>
      </div>
    </section>
  );
}

/** Privatisation Section */
function PrivatisationSection() {
  return (
    <section className="privatisation-section" id="privatisation">
      <div className="section-container">
        {/* Cave Voûtée */}
        <div className="privat-row">
          <div className="privat-image" style={{ backgroundImage: 'url(/assets/Tapas-6.jpeg)' }} />
          <div className="privat-content">
            <img src="/assets/Las-Tapas-11.svg" alt="" className="privat-decor floating top-right" />
            <img src="/assets/Las-Tapas-34.svg" alt="" className="privat-decor bottom-left" />
            <h3>La cave voûtée</h3>
            <p>
              Envie d'un anniversaire, d'un repas d'équipe ou d'un moment unique entre amis ?
              Notre cave voûtée vous accueille dans une ambiance feutrée et typiquement espagnole.
              Jusqu'à 12 personnes, avec menu sur mesure et service dédié.
            </p>
            <a href="#contact" className="btn-primary bounce">Je privatise</a>
          </div>
        </div>

        {/* Étage */}
        <div className="privat-row reverse" style={{ direction: 'rtl' }}>
          <div className="privat-content" style={{ direction: 'ltr' }}>
            <img src="/assets/Las-Tapas-11.svg" alt="" className="privat-decor floating top-left" />
            <img src="/assets/Las-Tapas-29.svg" alt="" className="privat-decor bottom-right" />
            <h3>Privatisez l'Étage</h3>
            <p>
              Envie d'un espace chaleureux et convivial pour votre événement ?
              Notre salon à l'étage vous accueille pour tous vos moments festifs ou
              professionnels, dans une ambiance typiquement espagnole.
              Jusqu'à 40 personnes en mode tapas & fiesta !
              Parfait pour : anniversaires, repas de groupe, afterworks, soirées privées...
            </p>
            <a href="#contact" className="btn-primary bounce">Je privatise</a>
          </div>
          <div className="privat-image" style={{ backgroundImage: 'url(/assets/Tapas-12.jpeg)' }} />
        </div>
      </div>
    </section>
  );
}

/** Gallery Section */
function GallerySection() {
  return (
    <section className="gallery-section" id="galerie">
      <div className="section-container">
        {/* Social icons */}
        <div className="social-icons" style={{ marginBottom: 30 }}>
          <a href="https://www.facebook.com/lastapaslille" target="_blank" rel="noopener noreferrer">
            <FacebookIcon />
          </a>
          <a href="https://www.instagram.com/lastapas_lille/" target="_blank" rel="noopener noreferrer">
            <InstagramIcon />
          </a>
        </div>

        {/* Header */}
        <div className="gallery-header">
          <h3 className="outlined-title">Galerie</h3>
          <h3 className="subtitle">Las Tapas en photos</h3>
        </div>

        <div className="section-decor-img">
          <img src="/assets/Las-Tapas-25.svg" alt="" />
        </div>

        {/* Carousel 1 - LTR */}
        <div className="gallery-carousel">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={5}
            centeredSlides
            loop
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            breakpoints={{
              0: { slidesPerView: 1.5 },
              480: { slidesPerView: 2.5 },
              768: { slidesPerView: 3.5 },
              1024: { slidesPerView: 5 },
            }}
          >
            {galleryPhotos1.map((photo) => (
              <SwiperSlide key={photo}>
                <img src={`/assets/${photo}`} alt="Las Tapas" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Carousel 2 - RTL */}
        <div className="gallery-carousel">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={4}
            loop
            autoplay={{ delay: 3000, disableOnInteraction: false, reverseDirection: true }}
            breakpoints={{
              0: { slidesPerView: 1.5 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >
            {galleryPhotos2.map((photo) => (
              <SwiperSlide key={photo}>
                <img src={`/assets/${photo}`} alt="Las Tapas" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

/** Map Section */
function MapSection() {
  return (
    <section className="map-section" id="contact">
      <iframe
        title="Las Tapas Lille"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2530.556!2d3.0595!3d50.6365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c2d5893dbe8e0d%3A0x7c6aae9a8d5a8c1a!2sLas%20Tapas!5e0!3m2!1sfr!2sfr!4v1"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        aria-label="Las Tapas Lille"
      />
      <div className="map-btn-container">
        <a
          href="https://maps.app.goo.gl/VfdehVh9H2H4ruFr9"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary bounce"
        >
          Itinéraire
        </a>
      </div>
    </section>
  );
}

/** Reviews Section */
function ReviewsSection() {
  return (
    <section className="reviews-section">
      <div className="section-container">
        <div className="reviews-header">
          <h3 className="outlined-title">Avis</h3>
          <h3 className="subtitle">Votre fidélité, notre plus belle récompense</h3>
        </div>

        <div className="section-decor-img">
          <img src="/assets/Las-Tapas-25.svg" alt="" />
        </div>

        <div className="reviews-container">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            loop
            autoplay={{ delay: 5000, disableOnInteraction: false }}
          >
            {reviews.map((review, i) => (
              <SwiperSlide key={i}>
                <div className="review-card">
                  <img src="/assets/google-provider.svg" alt="Google" className="google-icon" style={{ margin: '0 auto 10px' }} />
                  <div className="review-stars">★★★★★</div>
                  <p className="review-text">"{review.text}"</p>
                  <p className="review-author">{review.author}</p>
                  <p className="review-date">{review.date}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Suppliers */}
        <div className="suppliers-section">
          <h3>Nos Fournisseurs</h3>
          <Swiper
            className="suppliers-carousel"
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            loop
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              0: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
            }}
          >
            <SwiperSlide><img src="/assets/Berman.png" alt="Berman" /></SwiperSlide>
            <SwiperSlide><img src="/assets/Cuidad-de-Sansuena.png" alt="Ciudad de Sansuena" /></SwiperSlide>
            <SwiperSlide><img src="/assets/artequeso.png" alt="Artequeso" /></SwiperSlide>
          </Swiper>
        </div>

        {/* Follow */}
        <div className="follow-section">
          <h3>Nous suivre...</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/lastapaslille" target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </a>
            <a href="https://www.instagram.com/lastapas_lille/" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

/** Footer */
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-col">
          <a href="tel:+33320069659">
            <img src="/assets/Las-Tapas-37.svg" alt="Téléphone" className="footer-icon" />
            <p>03 20 06 96 59</p>
          </a>
        </div>
        <div className="footer-col footer-logo">
          <img src="/assets/Las-Tapas.png" alt="Las Tapas" />
          <div className="footer-social">
            <a href="https://www.instagram.com/lastapas_lille/" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
            <a href="https://www.facebook.com/lastapaslille" target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </a>
          </div>
        </div>
        <div className="footer-col">
          <img src="/assets/Las-Tapas-40.svg" alt="Adresse" className="footer-icon" />
          <p>116-118 Rue Saint-André, 59000 Lille</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          Copyright 2025 — Une création <a href="https://miaam.fr" target="_blank" rel="noopener noreferrer">Miaam</a>
          {' — '}
          <a href="/mentions-legales">Mentions légales</a>
          {' — '}
          <a href="/politique-de-cookies">Politique de cookies</a>
          {' — '}
          <a href="/politique-de-confidentialite">Politique de confidentialité</a>
        </p>
      </div>
    </footer>
  );
}

/** ZenChef Reservation Widget */
function ZenChefWidget() {
  useEffect(() => {
    // Add the config div
    if (!document.querySelector('.zc-widget-config')) {
      const configDiv = document.createElement('div');
      configDiv.className = 'zc-widget-config';
      configDiv.setAttribute('data-restaurant', '352016');
      configDiv.setAttribute('data-open', '3000');
      configDiv.setAttribute('data-position', 'right');
      document.body.appendChild(configDiv);
    }

    // Load the ZenChef SDK
    if (!document.getElementById('zenchef-sdk')) {
      const script = document.createElement('script');
      script.id = 'zenchef-sdk';
      script.async = true;
      script.src = 'https://sdk.zenchef.com/v1/sdk.min.js';
      document.body.appendChild(script);
    }

    return () => {
      // Cleanup on unmount
      const config = document.querySelector('.zc-widget-config');
      if (config) config.remove();
    };
  }, []);

  return null;
}

/* ======================== PAGES ======================== */

function HomePage() {
  return (
    <>
      <Hero />
      <CeramicBand direction="ltr" />
      <AboutSection />
      <CeramicBand direction="rtl" onRed />
      <PrivatisationSection />
      <GallerySection />
      <CeramicBand direction="ltr" />
      <MapSection />
      <ReviewsSection />
    </>
  );
}

/* ======================== APP ======================== */

function AppContent() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/la-carte" element={<LaCarte />} />
      </Routes>
      <Footer />
      <ZenChefWidget />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
